/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, September 6th 2022, 12:02:28 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ViewListIcon from "@mui/icons-material/ViewList";
import { IWorkflowViewType } from "./types";

interface WorkflowViewTogglerProps {
  workflowViewType: IWorkflowViewType;
  setWorkflowViewType: (workflowViewType: IWorkflowViewType) => void;
}

export const WorkflowViewToggler = ({ workflowViewType, setWorkflowViewType }: WorkflowViewTogglerProps) => {
  const showChartView = () => setWorkflowViewType("flowChart");

  const showListView = () => setWorkflowViewType("nodeList");

  const chartViewButtonStyle =
    workflowViewType === "flowChart" ? { borderRadius: 1, border: "1px solid" } : { borderRadius: 1 };

  const listViewButtonStyle =
    workflowViewType === "nodeList" ? { borderRadius: 1, border: "1px solid" } : { borderRadius: 1 };

  return (
    <Stack direction="row" spacing={1}>
      <Tooltip title={<Typography>Flowchart</Typography>} placement="top" arrow>
        <IconButton sx={chartViewButtonStyle} onClick={showChartView} color="secondary">
          <AccountTreeIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={<Typography>List</Typography>} placement="top" arrow>
        <IconButton sx={listViewButtonStyle} onClick={showListView} color="success">
          <ViewListIcon />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};
